import {alias, createModelSchema} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {RewardModel} from "@/modules/redactor/models/reward/RewardModel";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {SmartOfferBundleAnyPurchaseType} from "@/modules/redactor/models/smart-offer/bundle-any-purchase/SmartOfferBundleAnyPurchaseType";
import {TriggerUtils} from "@/modules/redactor/models/trigger/core/TriggerUtils";

export class SmartOfferBundleAnyPurchase extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.ANY_PURCHASE);

        this._type = null;
        this._reward = null;
        this._triggers = [];
    }

    get type() {
        return this._type;
    }

    set type(value) {
        this._type = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get triggers() {
        return this._triggers;
    }

    set triggers(value) {
        this._triggers = value;
    }

    valid() {

        if (!SmartOfferBundleAnyPurchaseType.is(this.type) || SmartOfferBundleAnyPurchaseType.isNone(this.type)) {
            return false;
        }

        if (!this.reward || this.reward.empty()) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        if (!this.triggers || this.triggers.length === 0) {
            return false;
        }

        if (this.triggers.some(v => !v || !v.valid())) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (!this.reward || this.reward.empty()) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleAnyPurchase());
        } else if (target instanceof SmartOfferBundleAnyPurchase) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleAnyPurchase, {
    _type: alias("type", SmartOfferBundleAnyPurchaseType.schema()),
    _reward: alias("reward", RewardModel.schema()),
    _triggers: alias("triggers", TriggerUtils.schema())
});
